<template>
  <div class="view-textlist" :id="field.key">
    <!-- Campo status con colores especiales usando el componente -->
    <ShippingStatusBadge
      v-if="field.key == 'status' && modelName == 'shipping' && item"
      :item="item"
      :model-name="modelName"
      size="small"
    />

    <span
      v-else-if="field.key == 'status' && modelName == 'shipping' && value"
      class="shipping-status-badge"
      :class="getStatusClass(Number(value))"
    >
      {{ getStatusLabel(Number(value), $t) }}
    </span>

    <!-- Mostrar lista de texto como elementos separados -->
    <div
      v-else-if="Array.isArray(value) && value.length > 0"
      class="textlist-container"
    >
      <div v-for="(item, index) in value" :key="index" class="textlist-item">
        <span class="textlist-bullet">•</span>
        <span class="textlist-text">{{ item }}</span>
      </div>
    </div>

    <!-- Mostrar texto simple si no es array -->
    <div v-else-if="value && !Array.isArray(value)" class="textlist-single">
      {{ value }}
    </div>

    <!-- Mostrar mensaje si está vacío -->
    <div v-else class="textlist-empty">
      <em>No items</em>
    </div>
  </div>
</template>

<script>
import ShippingStatusBadge from '../ShippingStatusBadge.vue';
import { getStatusClass, getStatusLabel } from '@/utils/shippingStatus';

export default {
  name: "ViewTextList",
  components: {
    ShippingStatusBadge,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Array],
      default: "",
    },
    modelName: {
      type: String,
      default: "",
    },
    item: {
      type: [Object, Array, Boolean],
      default: null,
    },
  },
  methods: {
    getStatusClass,
    getStatusLabel,
  },
};
</script>

